function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { scales } from "./types";
import { StyledTag } from "./StyledTag";
var Tag = function(_param) /*#__PURE__*/ {
    var startIcon = _param.startIcon, endIcon = _param.endIcon, children = _param.children, props = _objectWithoutProperties(_param, [
        "startIcon",
        "endIcon",
        "children"
    ]);
    return _jsxs(StyledTag, _objectSpread({}, props, {
        children: [
            /*#__PURE__*/ React.isValidElement(startIcon) && /*#__PURE__*/ React.cloneElement(startIcon, {
                mr: "0.5em"
            }),
            children,
            /*#__PURE__*/ React.isValidElement(endIcon) && /*#__PURE__*/ React.cloneElement(endIcon, {
                ml: "0.5em"
            })
        ]
    }));
};
/* eslint-disable react/default-props-match-prop-types */ Tag.defaultProps = {
    variant: "primary",
    scale: scales.MD,
    outline: false
};
export default Tag;
